import { supabase } from '../services/supabase/client';

export const DEFAULT_AVATAR_PATH = '/default-avatar.svg';
export const DEFAULT_COMPANY_IMAGE_PATH = '/default-company.svg';

/**
 * 將 users.profile_image / companies.profile_image 轉成可顯示的 URL：
 * 空值回 fallback；已是 http(s) 或 data URI 則原樣；其餘視為 Storage `avatars` bucket 路徑。
 */
export function resolveProfileImageUrl(
  profileImage: string | null | undefined,
  options?: { fallback?: string }
): string {
  const fallback = options?.fallback ?? DEFAULT_AVATAR_PATH;
  if (!profileImage || String(profileImage).trim() === '') {
    return fallback;
  }
  const trimmed = String(profileImage).trim();
  if (trimmed.startsWith('http') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  try {
    const { data } = supabase.storage.from('avatars').getPublicUrl(trimmed);
    if (data?.publicUrl) return data.publicUrl;
  } catch {
    // ignore
  }
  return fallback;
}
